import type { NodeViewDecorator } from './../../ricos-types';

import MentionDecorator from './mention';

export const nodeViewDecorators: NodeViewDecorator<JSX.Element>[] = [MentionDecorator];
